class ProductController {
  constructor() {
    this.name = 'product';
  }
}

export default ProductController;



// WEBPACK FOOTER //
// ./client/app/components/product/product.controller.js